const defaultState = {
  isLoaded: false,
  isAuthed: false,
  uid: null,
  displayName: null,
  photoURL: null
};

const state = Object.assign({}, defaultState);

const mutations = {
  RESET_USER_DATA(state) {
    Object.assign(state, defaultState);
  },
  SET_USER_DATA(state, userData) {
    state.isLoaded = true;
    if (!userData) {
      state.isAuthed = false;
      state.uid = null;
      state.displayName = null;
      state.photoURL = null;
      return;
    }
    const { uid, displayName, photoURL } = userData;
    state.isAuthed = true;
    state.uid = uid;
    state.displayName = displayName;
    state.photoURL = photoURL;
  }
};

const actions = {
  resetUserData: ({ commit }) => {
    commit('RESET_USER_DATA');
  },
  setUserData: ({ commit }, userData) => {
    commit('SET_USER_DATA', userData);
  }
};

export default {
  state,
  mutations,
  actions
};
